import React from 'react';
import { Trans } from '@lingui/react/macro';
import { Dropdown, DropdownButton } from '@ygtechnologies/rubus-ui';
import { faSortAmountDownAlt, faSortAmountUp, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export enum SortBy {
    Title = 'Title',
    Category = 'Category',
    Deadline = 'Deadline',
    Published = 'Published',
}

export interface SortProps {
    id: SortBy;
    direction: 'asc' | 'desc';
}

export interface SortDefinition {
    id: SortBy;
    labelGenerator: () => React.ReactNode;
}

export const sortDefinitions: SortDefinition[] = [
    {
        id: SortBy.Title,
        labelGenerator: () => <Trans>Title</Trans>,
    },
    {
        id: SortBy.Deadline,
        labelGenerator: () => <Trans>Deadline</Trans>,
    },
];

interface SortByDropdownProps {
    currentSort: SortProps;
    onSortChange: (sort: SortProps) => void;
}

export const SortByDropdown: React.FC<SortByDropdownProps> = ({ currentSort, onSortChange }) => {
    const currentSortDefinition = sortDefinitions.find((x) => x.id === currentSort.id);

    return (
        <DropdownButton
            variant="tertiary"
            label={
                <>
                    <span>
                        <Trans>Sort by</Trans>
                    </span>{' '}
                    {currentSortDefinition?.labelGenerator()}{' '}
                    {currentSort?.direction === 'desc' ? (
                        <FontAwesomeIcon icon={faSortAmountDownAlt} />
                    ) : (
                        <FontAwesomeIcon icon={faSortAmountUp} />
                    )}
                    <FontAwesomeIcon icon={faChevronDown} />
                </>
            }>
            {sortDefinitions.map((sort) => (
                <React.Fragment key={sort.id}>
                    <Dropdown.Item onClick={() => onSortChange({ id: sort.id, direction: 'asc' })}>
                        {sort.labelGenerator()} (<Trans>Ascending</Trans>)
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onSortChange({ id: sort.id, direction: 'desc' })}>
                        {sort.labelGenerator()} (<Trans>Descending</Trans>)
                    </Dropdown.Item>
                </React.Fragment>
            ))}
        </DropdownButton>
    );
};
